import { Trans } from "react-i18next";
import {
  cgPromotion1,
  cgPromotion2,
  cgPromotion3,
  cgPromotion4,
  cgPromotion5,
  cgPromotion6,
  cgPromotion7,
} from "../../img";

export const promoContent = [
  {
    img: cgPromotion1,
    title1: "promo1title1",
    title2: "promo1title2",
    desc: (
      <>
        <div>
          <Trans i18nKey="promo1Desc1" />
        </div>
        <div>
          <Trans i18nKey="promo1Desc2" />
        </div>
      </>
    ),
    category: ["all", "special"],
  },
  {
    img: cgPromotion2,
    title1: "promo2title1",
    title2: "promo2title2",
    desc: (
      <>
        <div>
          <Trans i18nKey="promo1Desc1" />
        </div>
        <div>
          <Trans i18nKey="promo2Desc1" />
        </div>
      </>
    ),
    category: ["all", "special"],
  },
  {
    img: cgPromotion3,
    title1: "promo3title1",
    title2: "promo3title2",
    desc: (
      <>
        <div>
          <Trans i18nKey="promo1Desc1" />
        </div>
        <div>
          <Trans i18nKey="promo3Desc1" />
        </div>
      </>
    ),
    category: ["all", "daily"],
  },
  {
    img: cgPromotion4,
    title1: "promo4title1",
    title2: "promo4title2",
    desc: (
      <>
        <div>
          <Trans i18nKey="promo1Desc1" />
        </div>
        <div>
          <Trans i18nKey="promo4Desc1" />
        </div>
      </>
    ),
    category: ["all", "cashRebate", "daily"],
  },
  {
    img: cgPromotion5,
    title1: "promo5title1",
    title2: "promo5title2",
    desc: (
      <>
        <div>
          <Trans i18nKey="promo1Desc1" />
        </div>
        <div>
          <Trans i18nKey="promo5Desc1" />
        </div>
      </>
    ),
    category: ["all", "special"],
  },
  {
    img: cgPromotion6,
    title1: "promo6title1",
    title2: "promo6title2",
    desc: (
      <>
        <div>
          <Trans i18nKey="promo1Desc1" />
        </div>
        <div>
          <Trans i18nKey="promo6Desc1" />
        </div>
      </>
    ),
    category: ["all", "newMember"],
  },
  {
    img: cgPromotion7,
    title1: "promo7title1",
    title2: "promo7title2",
    desc: (
      <>
        <div>
          <Trans i18nKey="promo1Desc1" />
        </div>
        <div>
          <Trans i18nKey="promo7Desc1" />
        </div>
      </>
    ),
    category: ["all", "special"],
  },
];
